import { makeStyles, Tooltip } from "@material-ui/core";
import React from "react";

interface CancelReasonFieldProps {
  cancelReason: string;
}

const useStyles = makeStyles(
  theme => ({
    cancelReason: {
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 2,
      display: "-webkit-box",
      overflow: "hidden",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        display: "unset"
      }
    }
  }),
  { name: "CancelReasonField" }
);

const CancelReasonField: React.FC<CancelReasonFieldProps> = props => {
  const { cancelReason } = props;
  const classes = useStyles(props);

  return (
    <Tooltip placement="bottom" title={cancelReason} interactive>
      <div onClick={e => e.stopPropagation()}>
        <div className={classes.cancelReason}>
          <span>{cancelReason}</span>
        </div>
      </div>
    </Tooltip>
  );
};

export default CancelReasonField;
